import { Button } from "antd";
import type { ContactDetails } from "./hooks/useContactDetails";
import ReadOnlyField from "./ReadOnlyField";
import TextField from "./TextField";

export interface ContactStepProps {
  name: string;
  phone: string;
  contact: ContactDetails;
}

export default function ContactStep({ name, phone, contact }: ContactStepProps) {
  const { address, updateAddress } = contact;

  return (
    <section className="sendin-panel">
      <h2>Kontaktinformasjon</h2>
      <div className="sendin-field-grid">
        <ReadOnlyField label="Navn" value={name} />
        <ReadOnlyField label="Telefon" value={phone} />
        <TextField
          label="E-post"
          value={contact.email}
          onChange={contact.updateEmail}
          onBlur={contact.markEmailTouched}
          error={contact.emailError}
          placeholder="navn@domene.no"
          inputMode="email"
          type="email"
          wide
        />
        <TextField
          label="Adresse"
          value={address.line1}
          onChange={(value) => updateAddress({ line1: value })}
          wide
        />
        <TextField
          label="Leilighet / c/o"
          value={address.line2}
          onChange={(value) => updateAddress({ line2: value })}
        />
        <TextField
          label="Postnummer"
          value={address.postalCode}
          onChange={(value) => updateAddress({ postalCode: value.replace(/\D/g, "").slice(0, 4) })}
          inputMode="numeric"
        />
        <TextField
          label="Poststed"
          value={address.city}
          onChange={(value) => updateAddress({ city: value })}
        />
        <TextField
          label="Kontonummer for utbetaling"
          value={contact.bankAccountNumber}
          onChange={contact.updateBankAccountNumber}
          onBlur={contact.markBankAccountTouched}
          error={contact.bankAccountError}
        />
        <TextField
          label="Eier av konto"
          value={contact.kontoEier}
          onChange={contact.setKontoEier}
        />
      </div>

      {contact.savedBankAccountAvailable ? (
        <Button className="sendin-secondary-button" onClick={contact.applySavedBankAccount}>
          Bruk lagret kontonummer
        </Button>
      ) : null}
    </section>
  );
}
